import { t } from "i18next";
import React, { useState } from "react";
import { CustomTooltip } from "../CustomTooltip/CustomTooltip";
import { useAppSelector } from "../../../services/hooks.service";
import "./AdjustmentTools.scss";

export const AdjustmentTools = (props) => {
  const lockLayout = useAppSelector((state) => state.persist.locked_layout);
  const { name, onClose, onExtend, onReduce } = props;

  const [extend, setExtend] = useState(false);

  const handleOnClose = () => {
    onClose(name);
  };

  const handleOnExtend = () => {
    onExtend(name);
    setExtend(true);
  };

  const handleOnReduce = () => {
    onReduce(name);
    setExtend(false);
  };

  return (
    <>
    <div className="draggable_space"></div>
    {lockLayout && 
    <CustomTooltip customClass="cust-tooltip-min" text={t("filter_options.lock_tooltip")}>
      <div className='tooltip_lock' />
    </CustomTooltip>}
    <ul className={`${lockLayout && 'locked'} card_adjustment_btn nondraggable_card`}>
      <li>
        <button
          data-test="zoom_view"
          onClick={() => {
            if (extend) {
              handleOnReduce();
            } else {
              handleOnExtend();
            }
          }}
          className="zoom_view"
        >
          {extend ? (
            <i className="far fa-compress-alt"></i>
          ) : (
            <i className="far fa-expand-alt"></i>
          )}
        </button>
      </li>
      {extend ? (
        ""
      ) : (
        <li>
          <button onClick={handleOnClose} data-test="close_view">
            <i className="far fa-times"></i>
          </button>
        </li>
      )}
    </ul>
    </>
  );
};

